import { Directive } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appPhone]'
})
export class PhoneDirective {

  constructor() { }
  validate(c: FormControl): ValidationErrors {
    const isValidPhoneNumber = /^\d{3,3}-\d{3,3}-\d{3,3}$/.test(c.value);
    const message = {
      'telephoneNumber': {
        'message': 'The phone number must be valid (XXX-XXX-XXX, where X is a digit)'
      }
    };
    return isValidPhoneNumber ? null : message;
  }
}
